import React from 'react';
import './dots.css';

export default function DotsLoader({ size= ''}) {
  return (
    <div className='dots-loader' style={{ width: size, height: size }} />
  )
};
